import { ModelBase } from 'store/model-base';

export class AdditionalDevicePayment extends ModelBase {
    public static storeName: string = 'additionalDevicePayment';
    public static idAttribute: string = 'deviceKey';

    public deviceKey: string;
    public isUsingNewCard: boolean;
    public isUsingSameAddress: boolean;
    public userData: OneTimePaymentNewCardInfo;
    public ccType: string;
    public ccLastFour: string;
    public amount: number;
}
